import React from 'react';
import { withRouter } from 'next/router';
import Router from 'next/router';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import PageBase from '../../components/layout/PageBase';
import ClientReview from '../../components/pages/reviews/ClientReview';
import {
  CLIENT_REVIEWS,
  ClientReviewType,
} from '../../components/pages/reviews/constants';
import { media } from '../../styles/base';
import { LeftNavIcon, RightNavIcon } from '../../components/utility/Icons';

const REVIEWS_PER_PAGE = 10;
const MAX_PAGES = Math.ceil(CLIENT_REVIEWS.length / REVIEWS_PER_PAGE);

const styles = createStyles({
  countStyle: {
    alignItems: 'center',
    color: '#323232',
    fontSize: 18,
    lineHeight: '22px',
  },
  headerInfo: {
    color: '#ffffff',
    fontisze: 14,
  },
  headerTitle: {
    paddingTop: 25,
  },
  leftDot: {
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    height: 10,
    marginRight: 15,
    width: 10,
  },
  pageCounterContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 25,
    justifyContent: 'space-between',
    margin: '75px auto 0',
    width: 175,
  },
  pageNavButtons: {
    borderRadius: '50%',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    height: 25,
    minWidth: 25,
    padding: 0,
  },
  reviewsContainer: {
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0 0 45px 0',
  },
  reviewsHeader: {
    background: 'linear-gradient(45deg, #443461 0%, #443461 100%)',
    backgroundImage:
      'url(/static/img/buying-guide/header_gradient_desktop.png)',
    backgroundPosition: 'bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 150,
    padding: 0,
    [media.tablet]: {
      backgroundImage:
        'url(/static/img/buying-guide/header_gradient_tablet.png)',
    },
    [media.mobile]: {
      backgroundImage:
        'url(/static/img/buying-guide/header_gradient_mobile.png)',
    },
  },
  rightDot: {
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    height: 10,
    marginLeft: 15,
    width: 10,
  },
  title: {
    color: '#ffffff',
    fontSize: 36,
    margin: 0,
    paddingTop: 0,
  },
});

interface Props {
  classes: any;
  router: any;
}

interface State {
  currentPage: number;
  reviewsToShow: any;
}

export class Reviews extends React.Component<Props, State> {
  state = {
    currentPage: 1,
    reviewsToShow: CLIENT_REVIEWS.slice(0, REVIEWS_PER_PAGE),
  };

  componentDidMount() {
    const { query } = this.props.router;
    if (query.page) {
      const pageNumber = parseInt(query.page, 10);
      if (pageNumber > 0 && pageNumber <= MAX_PAGES) {
        // Page number is less than max pages
        this._calculatePageData(pageNumber);
      } else {
        // Page number is greater than max pages, then show first page
        this._calculatePageData(1);
      }
    }
  }
  _renderCount = () => {
    return (
      <Typography
        className={this.props.classes.countStyle}
        style={{ color: '#323232' }}
      >
        Page {this.state.currentPage} of {MAX_PAGES}
      </Typography>
    );
  };

  _calculatePageData = (pageNumber: number) => {
    const begin = (pageNumber - 1) * REVIEWS_PER_PAGE;
    const end = begin + REVIEWS_PER_PAGE;
    this.setState(
      {
        currentPage: pageNumber,
        reviewsToShow: CLIENT_REVIEWS.slice(begin, end),
      },
      () => {
        Router.push({
          pathname: '/reviews',
          query: { page: pageNumber },
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    );
  };

  _handleNavigation = (nextPage: boolean) => {
    let pageNumber = this.state.currentPage;
    if (nextPage) {
      pageNumber = this.state.currentPage + 1;
    } else {
      pageNumber = this.state.currentPage - 1;
    }
    this._calculatePageData(pageNumber);
  };

  render() {
    const { classes } = this.props;
    const { reviewsToShow, currentPage } = this.state;
    return (
      <PageBase>
        <div
          className={`page-container col-xs-12 center-xs ${classes.reviewsContainer}`}
        >
          <div
            className={`col-xs-12 center-xs middle-xs ${classes.reviewsHeader}`}
          >
            <div className={`row center-xs middle-xs ${classes.headerTitle}`}>
              <div className={classes.leftDot} />
              <h1 className={classes.title}>Reviews</h1>
              <div className={classes.rightDot} />
            </div>
            <p className={classes.headerInfo}>
              See why home buyers love working with Torii
            </p>
          </div>
          <div style={{ marginTop: 50 }}>
            {reviewsToShow.map((review: ClientReviewType, index: number) => {
              return (
                <ClientReview
                  key={`${index}-${currentPage}`}
                  review={review}
                  hideBorderBottom={reviewsToShow.length === index + 1}
                />
              );
            })}
          </div>

          <div className={classes.pageCounterContainer}>
            <Button
              className={classes.pageNavButtons}
              disabled={currentPage === 1}
              onClick={() => this._handleNavigation(false)}
            >
              <LeftNavIcon small />
            </Button>
            {this._renderCount()}
            <Button
              className={classes.pageNavButtons}
              disabled={currentPage === MAX_PAGES}
              onClick={() => this._handleNavigation(true)}
            >
              <RightNavIcon small />
            </Button>
          </div>
        </div>
      </PageBase>
    );
  }
}

export default withStyles(styles)(withRouter(Reviews));
